import { TPAComponentProps } from '../../types';

export interface CustomDialogProps extends TPAComponentProps {
  /** The content to display inside the dialog element */
  children: any;
  /** Defines a string value that labels the dialog element */
  ['aria-label']?: string;
  /** Identifies the element that labels the dialog element */
  ['aria-labelledby']?: string;
  /** Defines an accessible description for the dialog by referring to its content */
  ['aria-describedby']?: string;
  /** Indicates if the dialog is shown or not */
  isOpen?: boolean;
  /** A callback to be invoked when the close button is clicked */
  onClose?(): void;
  /** Allows to to manage the focus manually instead of the internal focus trap */
  manualFocus?: boolean;
  /** In case the variable set to true, Dialog should be rendered under the document.body DOM node  */
  appendToBody?: boolean;
}

export interface CustomDialogDefaultProps {
  isOpen: boolean;
  manualFocus: boolean;
  appendToBody: boolean;
}

export interface CustomDialogState {}
